export interface UserCardInfo {
  name: string;
  type: string;
  imageUrl?: string;
}
